export const MASTER_PAGE_TOOGLE_MENU = 'MASTER_PAGE_TOOGLE_MENU';
export const MASTER_PAGE_NOTIFICACAO = 'MASTER_PAGE_NOTIFICACAO';
export const MASTER_PAGE_ON_BREAKPOINT = 'MASTER_PAGE_ON_BREAKPOINT';



// WEBPACK FOOTER //
// ./src/features/master-page/redux/constants.js